import React from 'react'
import {
  Box,
  Text,
  ImageLoader,
  useResponsiveWrapperContext,
} from '@usap/uicomponents'
import { BoxWithPointer, Heading3 } from '@usap/widgets'
import { formatBrand } from '../../../../../../../transformers/BrandText'
import generateItemDetails from '../../../../Items/Item/Details/hooks/generateItemDetails'
import { itemListBoxStyle, titleBoxStyle } from './style/constant'

const ItemDetail = ({ item }) => {
  const { isDesktop } = useResponsiveWrapperContext()

  const {
    sku,
    productImageUrl,
    title,
    brand,
  } = generateItemDetails(item)

  return (
    <Box height={itemListBoxStyle.height} key={sku}>
      <Box direction="row" wrap={false} gap="medium">
        <Box width="30%" align="center">
          <BoxWithPointer
            align="center"
            justify="center"
            height="140px"
            fxWidth={itemListBoxStyle.fxWidth}
          >
            <ImageLoader
              height="100%"
              width="100%"
              fit="contain"
              src={productImageUrl}
              alt={title}
              cloudinaryParams={isDesktop ? 'h_140,w_170' : 'h_140,w_75'}
            />
          </BoxWithPointer>
        </Box>

        <Box width="70%">
          <Box width="100%">
            <Heading3 title={formatBrand(brand)} />
          </Box>

          <Box width="100%">
            <Text
              id={`productTitle-${sku}`}
              size="small"
              color="dark-2"
              className="productTitle"
            >
              {title}
            </Text>
          </Box>

          <Box width="100%" pad={titleBoxStyle.pad}>
            <Text size="xsmall" color="dark-2">
              Part Number:&nbsp;
              {sku}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ItemDetail
